module.exports = __webpack_public_path__ + "static/media/contact-default.9185d391.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact-default.png
// module id = 52
// module chunks = 9